import { Chip, SwitchButton } from "@ui";
import style from "./AutoPayCell.module.scss";
import { IProxy } from "@interfaces/admin/proxy";
import { removeRowError } from "@global-state/pages/admin/myProxies/slice";
import { useUpdateProxyDataMutation } from "@RTKQuery/admin/proxy/proxy";
import { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "store/hooks";
import { IoClose } from "react-icons/io5";
import cn from "classnames";

export function AutoPayCell({ auto_pay, proxy_id }: { auto_pay: IProxy["auto_pay"], proxy_id: IProxy["id"] }) {
    const [updateProxyData, { isSuccess, reset }] = useUpdateProxyDataMutation();

    const {activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling} = useAppSelector(state => state.myProxiesAdminPage);

    const rowsIsError = useAppSelector(state => state.myProxiesAdminPage.rowsIsError)?.[proxy_id] || [];

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isSuccess) {
            dispatch(removeRowError({
                proxyId: proxy_id, 
                colName: "auto_pay"
            }))
        }
    }, [isSuccess])

    return (
        <div className={style.cell}>
            <SwitchButton
                checked={auto_pay}
                onChecked={() => { 
                    updateProxyData({
                        proxy_id,
                        params: {
                            page: activePaginationPage,
                            limit: activePaginationLimit,
                            router_id: activeSearchIdParameter,
                            operator: activeOperator,
                            phone_number: activeSearchPhoneParameter,
                            selling: activeSelling
                        },
                        body: {
                            auto_pay: !auto_pay
                        }
                    })
                }}
            />

            <div className={cn("absolute left-full top-1/2 pl-[5px] z-10 -translate-y-1/2", rowsIsError.includes("auto_pay") ? "block" : "hidden")}>
                <Chip
                    text="Помилка"
                    color="red"
                    icon={<IoClose
                        className="w-[15px] text-[#F81F1F] h-[15px] cursor-pointer"
                        onClick={() => {
                            reset();
                            dispatch(removeRowError({
                                proxyId: proxy_id, 
                                colName: "auto_pay"
                            }))
                        }}
                    />}
                    aligtIcon="right"
                />
            </div>
        </div>
    )
}